import { inject, Inject, Injectable } from '@angular/core';
import { COMMONS_ENV, NetworkService } from '@damofire/data-angular-commons';
import { HttpUtils } from '@damofire/data-commons';
import { WarehouseStateSnapshotMeta, WarehouseStateSnapshotPayload } from './warehouse-state-snapshot.dto';
import { SnapshotService } from './snapshot.service';

@Injectable()
export class FirebaseWarehouseStateSnapshotService extends SnapshotService {
  private readonly networkService = inject(NetworkService);

  constructor(@Inject(COMMONS_ENV) private readonly environment: any) {
    super();
  }

  override async listSnapshots(divisionId: string): Promise<WarehouseStateSnapshotMeta[]> {
    return this.get<WarehouseStateSnapshotMeta[]>(`ww-snapshots/divisions/${divisionId}/snapshots`);
  }

  override async getSnapshotMeta(snapshotId: string): Promise<WarehouseStateSnapshotMeta> {
    return this.get<WarehouseStateSnapshotMeta>(`ww-snapshots/${snapshotId}`);
  }

  override async getSnapshotPayload(snapshotId: string): Promise<WarehouseStateSnapshotPayload> {
    return this.get<WarehouseStateSnapshotPayload>(`ww-snapshots/${snapshotId}/payload`);
  }

  /**
   * Historical state is online-only. Failing fast while disconnected sends every caller down its
   * existing "back to current state" path instead of waiting on a request that cannot complete.
   */
  private async get<R>(ctxPath: string): Promise<R> {
    if (!this.networkService.connected) {
      throw new Error('Historical warehouse states require a connection.');
    }

    return HttpUtils.get<R>(this.environment.appConfig.fns, ctxPath);
  }
}
